import { Component, Input } from '@angular/core';
import { UploadConfirmInfo } from './confirm-info.interface';
import { ComputedFrom } from '@certemy/common';
import { DEFAULT_FILE_MAX_SIZE } from '@certemy/ui-components';

@Component({
  selector: 'cm-confirm-info',
  templateUrl: './confirm-info.component.html',
  styleUrls: ['./confirm-info.component.scss'],
})
export class ConfirmInfoComponent {
  @Input() info: UploadConfirmInfo;
  @Input() isEducation;
  @Input() fileInfoReqired = true;

  @ComputedFrom('info')
  get maxSize(): number {
    return this.info.maxSize || DEFAULT_FILE_MAX_SIZE;
  }
}
